<template>
  <skeleton v-if="loading && !keepAlive" />
  <tab-bar-layout v-else
                  class="page-my"
  >
    <my-header-new :auth="auth"
                   :avatar="user.avatar"
                   :name="user.name"
                   :show-point-entrance="showPointEntrance"
                   :my-point="myPoint"
                   :point-status="pointStatus"
    />
    <icon-grid :icon-grid="iconGrid"
               :express-list="expressList"
    />
    <router-link v-if="render && render.adInfo"
                 class="notify-info"
                 :to="render.adInfo.url"
                 v-ym-report:MARKETING_VIP_AD_MY_CLICK=
                   "{ ...render.adInfo, ymReporterRecordEntrySource: true }"
    >
      <ym-img class="notify-info-img"
              :src="render.adInfo.src"
              :alt="render.adInfo.desc"
      />
    </router-link>
    <menu-list :cell-data="cellData"
               :info-num="infoNum"
    />
    <welfare-btn v-if="render.welfare && render.welfare.show"
                 :show="render.welfare.show"
                 :src="render.welfare.src"
                 :url="render.welfare.url"
                 :width="welfareWidth"
    />
  </tab-bar-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Skeleton from '@/skeleton/MyIndex';
  import TabBarLayout from '@/layout/TabBarLayout';
  import MyHeaderNew from '@/pages/My/components/MyHeaderNew';
  import IconGrid from '@/pages/My/components/IconGrid';
  import MenuList from '@/pages/My/components/MenuList';
  import WelfareBtn from '@/pages/Audio/components/WelfareBtn';
  import { getMyInfo } from '@/services/user';
  import { getExpressEntry } from '@/services/express';
  import deepClone from '@/utils/deep-clone';

  const defaultData = {
    loading: false,
    keepAlive: false,

    iconGrid: [
      [{
        name: 'MyOrder',
        icon: 'order',
        title: '我的订单',
        auth: true,
      }, {
        name: 'MyGroupBuy',
        icon: 'group',
        title: '我的拼团',
        auth: true,
      }, {
        name: 'MyGiveRecord',
        icon: 'gift',
        title: '赠送记录',
        auth: true,
      }, {
        name: 'MyCoupon',
        icon: 'coupon',
        title: '优惠券',
        auth: true,
      }, {
        name: 'MyCollect',
        icon: 'collect',
        title: '我的收藏',
        auth: true,
      }],
    ],
    cellData: [
      [{
        name: 'MyInformation',
        title: '消息中心',
        icon: 'message',
      }, {
        name: 'HelpCenter',
        title: '帮助中心',
        icon: 'question',
      }, {
        name: 'Feedback',
        title: '意见反馈',
        icon: 'feedback',
      }, {
        name: 'MyRemind',
        title: '订阅开课提醒',
        icon: 'remind',
        auth: true,
      }, {
        name: 'SystemSetting',
        title: '设置',
        icon: 'setting',
      }, {
        name: 'AboutUs',
        title: '关于我们',
        icon: 'about',
      }],
    ],
    expressList: [],
    render: {
      pointInfo: null,
      adInfo: null,
      showCustomService: false,
      welfare: null,
    },
  };

  export default {
    name: 'PageMy',
    metaInfo: {},
    components: {
      Skeleton,
      TabBarLayout,
      WelfareBtn,
      MyHeaderNew,
      IconGrid,
      MenuList,
    },
    data() {
      return deepClone(defaultData);
    },
    computed: {
      ...mapGetters([
        'auth',
        'user',
        'userNotifyDot',
      ]),
      welfareWidth() {
        const { welfare } = this.render;
        return welfare && welfare.width ? parseInt(welfare.width, 10) : 160;
      },
      isLogin() {
        return Boolean(this.auth && this.auth !== '');
      },
      infoNum() {
        const { userNotifyDot: redDot } = this;
        return Number(redDot.newMessage) + Number(redDot.newNotification);
      },
      showPointEntrance() {
        return this.isLogin && !!this.render.pointInfo;
      },
      myPoint() {
        const { pointInfo } = this.render;
        if (!pointInfo) return 0;
        return pointInfo.point === 0 ? 0 : pointInfo.point;
      },
      pointStatus() {
        const { pointInfo } = this.render;
        if (!pointInfo) return 'lock';
        return pointInfo.status;
      },
    },
    methods: {
      ...mapActions([
        'updateUser',
        'updateUserNotifyDot',
      ]),
      async getExpressEntry() {
        const expressData = await getExpressEntry();
        this.expressList = this.generateExpressData(expressData.list);
      },
      async getMyInfoData() {
        this.loading = true;

        const data = await getMyInfo();
        // 更新用户信息
        this.updateUser(data.user);
        // 更新红点
        this.updateUserNotifyDot(data.redDot);

        this.render = data.render;
        this.loading = false;
        this.keepAlive = true;
        this.render = data.render;
      },
      // 修改状态信息
      modifyStatus(status) {
        switch (status) {
          case '发货': {
            return '已发货';
          }
          case '揽收': {
            return '已揽收';
          }
          case '在途': {
            return '运输中';
          }
          case '派件': {
            return '派送中';
          }
          case '签收': {
            return '已签收';
          }
          default: {
            return status;
          }
        }
      },
      generateExpressData(data) {
        const res = [];
        data.forEach((item) => {
          const {
            title,
            status,
            stateContent,
            postId,
          } = item;

          let statusBlock = res[res.length - 1];
          if (status !== '签收') {
            statusBlock = {
              title,
              status: this.modifyStatus(status),
              stateContent,
              postId,
            };
            res.push(statusBlock);
          }
        });
        return res;
      },
    },
    activated() {
      if (this.auth) {
        this.getMyInfoData();
        this.getExpressEntry();
        return;
      }
      const deepData = deepClone(defaultData);
      Object.keys(deepData).forEach((key) => {
        this[key] = deepData[key];
      });
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .notify-info {
    display: block;
    max-width: 750px;
    margin: @size-base auto 0;
  }

  .notify-info-img {
    display: block;
    width: 100%;
    margin: 0 auto;
  }
</style>
